import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import _, { mapKeys } from 'lodash';

import Loader from '@common/components/loader';
import { configTypeMap } from '@app/dev/terminal/components/eventTypeFilter/constants';
import EventTypeFilter from '@app/dev/terminal/components/eventTypeFilter';
import CasinoAndLiveCasinoViewer from '../../components/casinoAndLiveCasinoViewer';
import CMSApi from '../../../services/cmsApi';
import { keyMapper } from './constants';

import './style.scss';

export const LiveCasinoWrapper = () => {
  const [data, setData] = useState({});
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();
  const routePath = '/liveCasino';

  const { gameId } = useParams();

  const loadGames = async () => {
    const { games } = await CMSApi.getLiveCasinoGames({ count: 'all' });
    return setData({ games });
  };

  const providers = useMemo(() => {
    if (!data?.games) return [];
    const allList = data.games.map((item) => _.pick(item, 'provider_title', 'provider'));
    const uniqByList = _.uniqBy(allList, 'provider');
    const mappedList = uniqByList.map((item) => mapKeys(item, (value, key) => keyMapper[key] || key));
    return mappedList;
  }, [data]);

  const gameList = useMemo(() => {
    if (searchValue) {
      return data?.games.filter((item) => Object.values(item)
        .some((value) => String(value)
          .toLowerCase()
          .includes(searchValue.toLowerCase())));
    }
    if (!selectedProviders.length) return data?.games;
    return data?.games.filter((item) => Object.values(item)
      .some((value) => selectedProviders.includes(value)));
  }, [data, selectedProviders, searchValue]);

  const toggleProvider = (provider) => {
    if (gameId) navigate(routePath);

    let newProviders = selectedProviders;

    if (selectedProviders.find((item) => item === provider)) {
      newProviders = selectedProviders.filter((item) => item !== provider);
    } else {
      newProviders = selectedProviders.concat(provider);
    }

    setSelectedProviders(newProviders);
  };

  const onSearchChange = (value) => {
    if (value.length >= 3) {
      setSearchValue(value);
    } else {
      setSearchValue('');
    }
  };

  useEffect(() => {
    loadGames();
  }, []);

  if (!data.games?.length) return <div className="loading"><Loader /></div>;

  return (
    <div className="import-view-container with-type-filter casino-view">
      <EventTypeFilter
        searchText={searchValue}
        setSearchText={setSearchValue}
        listType="liveCasino"
        configType={configTypeMap.casino}
      />
      <CasinoAndLiveCasinoViewer
        categoryId={28}
        selectedProviders={selectedProviders}
        providers={providers}
        toggleProvider={toggleProvider}
        gameId={gameId}
        gamesData={{
          list: gameList,
          total: gameList?.length,
        }}
        onSearchChange={onSearchChange}
        searchValue={searchValue}
        routePath={routePath}
      />
    </div>
  );
};
